import Iframe from "@components/CustomTypography/Iframe/Iframe"
import Paragraph from "@components/CustomTypography/Paragraph/Paragraph"
import Title from "@components/CustomTypography/Title/Title"
import ButtonSwitcher from "@components/Switchers/ButtonSwitcher/ButtonSwitcher"
import {AdvancedSideAssetMainContent} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./CustomerHeader.module.scss"

type Props = {
	data: AdvancedSideAssetMainContent
}

const CustomerHeader = (props: Props) => {
	return (
		<div className={styles.headerContainer}>
			<div className={styles.contentWrapper}>
				<div className={styles.contentBox}>
					<Title content={props.data.title} size={"XL"} type={"1"} />
					<Paragraph content={props.data.subtitle} size={"S"} />
				</div>
				<div className={styles.buttonBox}>
					<ButtonSwitcher buttonsList={props.data} withoutTarget />
				</div>
			</div>
			<div className={styles.iframeWrapper}>
				{props.data.preview && <Iframe {...props.data.preview} />}
			</div>
		</div>
	)
}

export default CustomerHeader
